/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Collapse } from 'react-collapse';
import ReactHtmlParser from 'react-html-parser';
import { useDispatch } from 'react-redux';
import { useMediaQuery } from 'react-responsive';
import { Element } from 'react-scroll';
import { CollapseDown } from '../../static';

const ArrowIcon = () => (
  <svg width="180" height="33" viewBox="0 0 180 33" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M167.47 31.5303C167.763 31.8232 168.237 31.8232 168.53 31.5303L173.303 26.7574C173.596 26.4645 173.596 25.9896 173.303 25.6967C173.01 25.4038 172.536 25.4038 172.243 25.6967L168 29.9393L163.757 25.6967C163.464 25.4038 162.99 25.4038 162.697 25.6967C162.404 25.9896 162.404 26.4645 162.697 26.7574L167.47 31.5303ZM2.75 31V28.75H1.25V31H2.75ZM2.75 24.25V19.75H1.25V24.25H2.75ZM2.75 15.25V10.75H1.25V15.25H2.75ZM2.75 6.25V4H1.25V6.25H2.75ZM2.75 4C2.75 3.82913 2.78387 3.66806 2.84456 3.52171L1.45897 2.94713C1.32408 3.27242 1.25 3.6285 1.25 4H2.75ZM3.52171 2.84456C3.66806 2.78387 3.82913 2.75 4 2.75V1.25C3.62851 1.25 3.27242 1.32408 2.94713 1.45897L3.52171 2.84456ZM4 2.75H6.025V1.25H4V2.75ZM10.075 2.75H14.125V1.25H10.075V2.75ZM18.175 2.75H22.225V1.25H18.175V2.75ZM26.275 2.75H30.325V1.25H26.275V2.75ZM34.375 2.75H38.425V1.25H34.375V2.75ZM42.475 2.75H46.525V1.25H42.475V2.75ZM50.575 2.75H54.625V1.25H50.575V2.75ZM58.675 2.75H62.725V1.25H58.675V2.75ZM66.775 2.75H70.825V1.25H66.775V2.75ZM74.875 2.75H78.925V1.25H74.875V2.75ZM82.975 2.75H87.025V1.25H82.975V2.75ZM91.075 2.75H95.125V1.25H91.075V2.75ZM99.175 2.75H103.225V1.25H99.175V2.75ZM107.275 2.75H111.325V1.25H107.275V2.75ZM115.375 2.75H119.425V1.25H115.375V2.75ZM123.475 2.75H127.525V1.25H123.475V2.75ZM131.575 2.75H135.625V1.25H131.575V2.75ZM139.675 2.75H143.725V1.25H139.675V2.75ZM147.775 2.75H151.825V1.25H147.775V2.75ZM155.875 2.75H159.925V1.25H155.875V2.75ZM163.975 2.75H166V1.25H163.975V2.75ZM166 2.75C166.171 2.75 166.332 2.78387 166.478 2.84456L167.053 1.45897C166.728 1.32408 166.371 1.25 166 1.25V2.75ZM167.155 3.52171C167.216 3.66806 167.25 3.82913 167.25 4H168.75C168.75 3.62851 168.676 3.27242 168.541 2.94713L167.155 3.52171ZM167.25 4V6.25H168.75V4H167.25ZM167.25 10.75V15.25H168.75V10.75H167.25ZM167.25 19.75V24.25H168.75V19.75H167.25ZM167.25 28.75V31H168.75V28.75H167.25ZM166.939 32.0607C167.525 32.6464 168.475 32.6464 169.061 32.0607L178.607 22.5147C179.192 21.9289 179.192 20.9792 178.607 20.3934C178.021 19.8076 177.071 19.8076 176.485 20.3934L168 28.8787L159.515 20.3934C158.929 19.8076 157.979 19.8076 157.393 20.3934C156.808 20.9792 156.808 21.9289 157.393 22.5147L166.939 32.0607ZM3.5 31V28.75H0.5V31H3.5ZM3.5 24.25V19.75H0.5V24.25H3.5ZM3.5 15.25V10.75H0.5V15.25H3.5ZM3.5 6.25V4H0.5V6.25H3.5ZM3.5 4C3.5 3.92944 3.51377 3.86588 3.53735 3.809L0.766172 2.65984C0.594179 3.0746 0.5 3.52819 0.5 4H3.5ZM3.809 3.53735C3.86588 3.51377 3.92944 3.5 4 3.5V0.5C3.52819 0.5 3.0746 0.594179 2.65984 0.766172L3.809 3.53735ZM4 3.5H6.025V0.5H4V3.5ZM10.075 3.5H14.125V0.5H10.075V3.5ZM18.175 3.5H22.225V0.5H18.175V3.5ZM26.275 3.5H30.325V0.5H26.275V3.5ZM34.375 3.5H38.425V0.5H34.375V3.5ZM42.475 3.5H46.525V0.5H42.475V3.5ZM50.575 3.5H54.625V0.5H50.575V3.5ZM58.675 3.5H62.725V0.5H58.675V3.5ZM66.775 3.5H70.825V0.5H66.775V3.5ZM74.875 3.5H78.925V0.5H74.875V3.5ZM82.975 3.5H87.025V0.5H82.975V3.5ZM91.075 3.5H95.125V0.5H91.075V3.5ZM99.175 3.5H103.225V0.5H99.175V3.5ZM107.275 3.5H111.325V0.5H107.275V3.5ZM115.375 3.5H119.425V0.5H115.375V3.5ZM123.475 3.5H127.525V0.5H123.475V3.5ZM131.575 3.5H135.625V0.5H131.575V3.5ZM139.675 3.5H143.725V0.5H139.675V3.5ZM147.775 3.5H151.825V0.5H147.775V3.5ZM155.875 3.5H159.925V0.5H155.875V3.5ZM163.975 3.5H166V0.5H163.975V3.5ZM166 3.5C166.071 3.5 166.134 3.51377 166.191 3.53735L167.34 0.766172C166.925 0.594179 166.472 0.5 166 0.5V3.5ZM166.463 3.80901C166.486 3.86588 166.5 3.92944 166.5 4H169.5C169.5 3.52819 169.406 3.0746 169.234 2.65984L166.463 3.80901ZM166.5 4V6.25H169.5V4H166.5ZM166.5 10.75V15.25H169.5V10.75H166.5ZM166.5 19.75V24.25H169.5V19.75H166.5ZM166.5 28.75V31H169.5V28.75H166.5Z"
      fill="#FF0F4F"
    />
  </svg>
);

const TableRow = ({ question, answer, mob = false }) => {
  const [open, setOpen] = useState(false);

  return (
    <div className={`${mob ? '' : 'mb-3'}`}>
      <a
        className={`d-flex justify-content-between hosted-table align-items-center ${
          open ? 'hosted-table-selected' : ''
        }`}
        onClick={() => setOpen(!open)}
        aria-controls="class-content"
        aria-expanded={open}
        style={{ borderRadius: '0' }}
      >
        <h1 className="faq-page__title faq-page__side-card m-0" style={{ padding: '0' }}>
          {question}
        </h1>
        {!open ? (
          <CollapseDown />
        ) : (
          <svg
            width="12"
            height="8"
            viewBox="0 0 12 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10.59 7.41016L6 2.83016L1.41 7.41016L0 6.00016L6 0.000156403L12 6.00016L10.59 7.41016Z"
              fill="black"
            />
          </svg>
        )}
      </a>
      <Collapse isOpened={open}>
        <div id="class-content">
          <div className="hosted-table-subcontent">{ReactHtmlParser(answer)}</div>
        </div>
      </Collapse>
    </div>
  );
};

const TableRowMob = ({ faq }) => {
  const [open, setOpen] = useState(false);

  return (
    <div className="mb-3">
      <a
        className={`d-flex justify-content-between hosted-table align-items-center ${
          open ? 'hosted-table-selected' : ''
        }`}
        onClick={() => setOpen(!open)}
        aria-controls="class-content"
        aria-expanded={open}
        style={{ borderRadius: '0' }}
      >
        <h1 className="faq-page__title-big faq-page__side-card">{faq.name}</h1>
        {!open ? (
          <CollapseDown />
        ) : (
          <svg
            width="12"
            height="8"
            viewBox="0 0 12 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10.59 7.41016L6 2.83016L1.41 7.41016L0 6.00016L6 0.000156403L12 6.00016L10.59 7.41016Z"
              fill="black"
            />
          </svg>
        )}
      </a>
      <Collapse isOpened={open}>
        {faq.faqs.map((el) => (
          <TableRow question={el.question} answer={el.answer} mob />
        ))}
      </Collapse>
    </div>
  );
};

const FaqComponent = () => {
  const isFour = useMediaQuery({ minWidth: 1318 });
  const isThree = useMediaQuery({ minWidth: 909, maxWidth: 1317 });
  const isTwo = useMediaQuery({ minWidth: 616, maxWidth: 908 });
  const isSingle = useMediaQuery({ maxWidth: 615 });
  const [faqs, setFaqs] = useState(null);
  const dispatch = useDispatch();

  const fetchFaq = () => {
    dispatch({ type: 'TOGGLE_LOADING_TRUE' });
    const access_token = localStorage.getItem('access_token');
    axios
      .get(`${window.$API_URL}api/faq-group/all/`, {
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${access_token}` },
      })
      .then(({ data }) => {
        dispatch({ type: 'TOGGLE_LOADING_FALSE' });
        setFaqs(data.data);
      })
      .catch((error) => {
        dispatch({ type: 'TOGGLE_LOADING_FALSE' });
      });
  };

  useEffect(() => {
    fetchFaq();
  }, []);

  return (
    <>
      {faqs !== null ? (
        <>
          <div className="faq-new">
            <div>
              <section>
                <div>
                  <div>
                    <div>
                      <p>1</p>
                    </div>
                  </div>
                </div>
                <div>
                  <div>
                    <img src="/images/faq/1.png" alt="" />
                  </div>
                </div>
                <h2>Membeli Pelatihan di Mitra Resmi</h2>
                <p>(Pijar Mahir, Pintaria, BukaLapak, MauBelajarApa dan Sekolah.mu)</p>
              </section>
              {!isSingle ? (
                <div>
                  <ArrowIcon />
                </div>
              ) : (
                ''
              )}
              <section className="faq-section-no-p">
                <div>
                  <div>
                    <div>
                      <p>2</p>
                    </div>
                  </div>
                </div>
                <div>
                  <div>
                    <img src="/images/faq/2.png" alt="" />
                  </div>
                </div>
                <h2>Tukarkan Voucher yang sudah kamu beli</h2>
              </section>
              {!isTwo && !isSingle ? (
                <div>
                  <ArrowIcon />
                </div>
              ) : (
                ''
              )}
              <section className="faq-section-no-p">
                <div>
                  <div>
                    <div>
                      <p>3</p>
                    </div>
                  </div>
                </div>
                <div>
                  <div>
                    <img src="/images/faq/3.png" alt="" />
                  </div>
                </div>
                <h2>Ikuti Pelatihan di MyEduSolveX</h2>
              </section>
              {!isThree && !isSingle ? (
                <div>
                  <ArrowIcon />
                </div>
              ) : (
                ''
              )}
              <section>
                <div>
                  <div>
                    <div>
                      <p>4</p>
                    </div>
                  </div>
                </div>
                <div>
                  <div>
                    <img src="/images/faq/4.png" alt="" />
                  </div>
                </div>
                <h2>Sesi QnA</h2>
                <p>(Tidak Untuk Semua Kelas)</p>
              </section>
              {!isFour && !isTwo && !isSingle ? (
                <div>
                  <ArrowIcon />
                </div>
              ) : (
                ''
              )}
              <section>
                <div>
                  <div>
                    <div>
                      <p>5</p>
                    </div>
                  </div>
                </div>
                <div>
                  <div>
                    <img src="/images/faq/5.png" alt="" />
                  </div>
                </div>
                <h2>Mengerjakan Exam</h2>
                <p>(Nilai minimal kelulusan 60)</p>
              </section>
              {!isSingle ? (
                <div>
                  <ArrowIcon />
                </div>
              ) : (
                ''
              )}
              <section className="faq-section-no-p">
                <div>
                  <div>
                    <div>
                      <p>6</p>
                    </div>
                  </div>
                </div>
                <div>
                  <div>
                    <img src="/images/faq/6.png" alt="" />
                  </div>
                </div>
                <h2>Memberi rating dan Ulasan</h2>
              </section>
              {!isThree && !isTwo && !isSingle ? (
                <div>
                  <ArrowIcon />
                </div>
              ) : (
                ''
              )}
              <section className="faq-section-no-p">
                <div>
                  <div>
                    <div>
                      <p>7</p>
                    </div>
                  </div>
                </div>
                <div>
                  <div>
                    <img src="/images/faq/7.png" alt="" />
                  </div>
                </div>
                <h2>Unduh sertifikat di MyEduSolveX</h2>
              </section>
              {!isSingle ? (
                <div>
                  <ArrowIcon />
                </div>
              ) : (
                ''
              )}
              <section>
                <div>
                  <div>
                    <div>
                      <p>8</p>
                    </div>
                  </div>
                </div>
                <div>
                  <div>
                    <img src="/images/faq/8.png" alt="" />
                  </div>
                </div>
                <h2>Proses pelatihan selesai</h2>
                <p>(Sudah memberikan rating dan ulasan dan mendapatkan sertifikat)</p>
              </section>
              {!isFour && !isTwo && !isSingle ? (
                <div>
                  <ArrowIcon />
                </div>
              ) : (
                ''
              )}
              <section>
                <div>
                  <div>
                    <div>
                      <p>9</p>
                    </div>
                  </div>
                </div>
                <div>
                  <div>
                    <img src="/images/faq/9.png" alt="" />
                  </div>
                </div>
                <h2>Data kamu di kirimkan ke mitra resmi </h2>
                <p>
                  (Pijar Mahir, Pintaria, BukaLapak, MauBelajarApa dan Sekolah.mu) Proses
                  pembelajaran di MyEdusolveX berakhir.
                </p>
              </section>
              {!isThree && !isSingle ? (
                <div>
                  <ArrowIcon />
                </div>
              ) : (
                ''
              )}
              <section className="faq-section-two-digits">
                <div>
                  <div>
                    <div>
                      <p>10</p>
                    </div>
                  </div>
                </div>
                <div>
                  <div>
                    <img src="/images/faq/10.png" alt="" />
                  </div>
                </div>
                <h2>Mitra platform Prakerja </h2>
                <p>akan melakukan penyelesaian kelas ke PMO dari program Kartu Prakerja</p>
              </section>
              {!isTwo && !isSingle ? (
                <div>
                  <ArrowIcon />
                </div>
              ) : (
                ''
              )}
              <section className="faq-section-two-digits">
                <div>
                  <div>
                    <div>
                      <p>11</p>
                    </div>
                  </div>
                </div>
                <div>
                  <div>
                    <img src="/images/faq/11.png" alt="" />
                  </div>
                </div>
                <h2>Pihak Kartu Prakerja </h2>
                <p>akan memverifikasi semua data peserta dalam 5-9 hari kerja</p>
              </section>
              {!isSingle ? (
                <div>
                  <ArrowIcon />
                </div>
              ) : (
                ''
              )}
              <section className="faq-section-two-digits">
                <div>
                  <div>
                    <div>
                      <p>12</p>
                    </div>
                  </div>
                </div>
                <div>
                  <div>
                    <img src="/images/faq/12.png" alt="" />
                  </div>
                </div>
                <h2>Sertifikat akan Tampil di dashboard</h2>
                <p>(pastikan anda juga memberikan ulasan di dashbord prakerja)</p>
              </section>
            </div>
          </div>
          <div className="faq-page">
            <div className="faq-page__main navbar-desc">
              {faqs.map((el, i) => (
                <Element name={i} className=" mb-5">
                  <h1 className="faq-page__title-big mb-3 text-mob-center faq-page__side-card">
                    {el.name}
                  </h1>
                  {el.faqs.map((el) => (
                    <TableRow question={el.question} answer={el.answer} />
                  ))}
                </Element>
              ))}
            </div>
            <div className="navbar-mob">
              <div className="faq-page__main">
                {faqs.map((el, i) => (
                  <TableRowMob faq={el} />
                ))}
              </div>
            </div>
          </div>
        </>
      ) : (
        ''
      )}
    </>
  );
};

export default FaqComponent;
